import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { breakpoints, colors, fontSizes, fontWeights } from 'theme/variables';
import { Antd3Form } from 'common/components/deprecated/antd3';

export const MainFormHeader = styled.h2`
    color: ${colors.secondaryColor};
    font-size: 1.15rem;
    font-weight: ${fontWeights.bold};
    letter-spacing: -0.2px;
    margin: 0 0 1.25rem;

    ${breakpoints.small} {
        font-size: 1.3rem;
    }
`;

export const FormHeader = styled.h2`
    color: ${colors.secondaryColor};
    font-size: 1.05rem;
    font-weight: ${fontWeights.bold};
    letter-spacing: -0.2px;
    margin: 0 0 1.25rem;

    ${breakpoints.small} {
        font-size: 1.15rem;
    }
`;

export const SubmitButtonContainer = styled(Antd3Form.Item)`
    margin-bottom: 0;
    button {
        width: 100%;
    }
`;

export const MarginLink = styled(Link)`
    margin: 25px 0;
`;
